import { useTranslation } from "react-i18next";

const LinkedIn = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5 shrink-0" aria-hidden focusable="false">
    <rect width="24" height="24" rx="4" fill="#0A66C2" />
    <rect x="5" y="9.5" width="3" height="9" fill="#fff" /><circle cx="6.5" cy="6.4" r="1.75" fill="#fff" />
    <path d="M10.5 9.5h2.9v1.3c.5-.9 1.6-1.6 3.1-1.6 2.6 0 3.5 1.6 3.5 4.3v5h-3v-4.5c0-1.2-.3-2.1-1.5-2.1s-2 .9-2 2.2v4.4h-3z" fill="#fff" />
  </svg>
);
const Instagram = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5 shrink-0" aria-hidden focusable="false">
    <defs><radialGradient id="ig-grad" cx="30%" cy="107%" r="150%"><stop offset="0" stopColor="#fdf497" /><stop offset=".05" stopColor="#fdf497" /><stop offset=".45" stopColor="#fd5949" /><stop offset=".6" stopColor="#d6249f" /><stop offset=".9" stopColor="#285AEB" /></radialGradient></defs>
    <rect width="24" height="24" rx="6" fill="url(#ig-grad)" />
    <rect x="5" y="5" width="14" height="14" rx="4" fill="none" stroke="#fff" strokeWidth="1.8" />
    <circle cx="12" cy="12" r="3.3" fill="none" stroke="#fff" strokeWidth="1.8" /><circle cx="16.3" cy="7.7" r="1" fill="#fff" />
  </svg>
);
const ICONS = { linkedin: LinkedIn, instagram: Instagram };
const safe = (u) => /^https:\/\/[^\s"'<>]+$/.test(u || "");

export function ProfileLinks({ name, links }) {
  const { t } = useTranslation();
  const ls = (links || []).filter((l) => safe(l.url) && l.label);
  if (!ls.length) return null;
  return (
    <div className="mt-6" data-testid="author-links">
      <p className="text-xs font-semibold uppercase tracking-[0.16em] text-clay-strong">{t("b8.online")}</p>
      <ul className="mt-2 flex flex-wrap gap-2">{ls.map((l) => { const Icon = ICONS[l.kind]; return (
        <li key={l.url}><a href={l.url} target="_blank" rel="noopener noreferrer" aria-label={t("b8.on_net", { name, net: l.label })} title={t("b8.new_tab")} data-testid={`author-link-${l.kind || "other"}`}
          className="inline-flex min-h-[44px] items-center gap-2 rounded-full border border-sand-line bg-card px-4 text-[15px] font-semibold text-ink shadow-xs transition-[transform,border-color] duration-200 hover:-translate-y-0.5 hover:border-ink">
          {Icon && <Icon />}{l.label}</a></li>); })}</ul>
    </div>
  );
}
